'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = require('bluebird');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Poller = function () {
  function Poller(store, config) {
    _classCallCheck(this, Poller);

    this.main = config.main;
    this.frequency = config.frequency || 1000;
    this.running = false;
    this.initialState = config.initialState;
    this.store = store;
    this.checkStart = config.checkStart;
    this.checkRun = config.checkRun;
    this.checkStop = config.checkStop;
  }

  _createClass(Poller, [{
    key: 'start',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var state;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.running = true;
                state = this.initialState;

              case 2:
                if (!this.running) {
                  _context.next = 11;
                  break;
                }

                if (!this.doCheckRun(state)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 6;
                return this.doMain(state);

              case 6:
                state = _context.sent;

              case 7:
                _context.next = 9;
                return (0, _bluebird.delay)(this.frequency);

              case 9:
                _context.next = 2;
                break;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _ref.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: 'doCheckRun',
    value: function doCheckRun(state) {
      if (!this.checkRun) {
        return true;
      }
      // only run getState if runner needs it
      if (this.checkRun.length !== 2) {
        return this.checkRun(state);
      }
      return this.checkRun(state, this.store.getState());
    }
  }, {
    key: 'doMain',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(state) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.main.length === 2)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', this.main(state, this.store.getState()));

              case 2:
                return _context2.abrupt('return', this.main(state));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function doMain(_x) {
        return _ref2.apply(this, arguments);
      }

      return doMain;
    }()
  }, {
    key: 'stop',
    value: function stop() {
      this.running = false;
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.running;
    }
  }]);

  return Poller;
}();

exports.default = function (store, config) {
  var poller = void 0;
  var newPoller = function newPoller() {
    return new Poller(store, config);
  };
  return function (next) {
    return function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {
        var prevState, afterState;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                prevState = store.getState();

                next(action);
                afterState = store.getState();


                if (config.onAction) {
                  config.onAction(action);
                }

                if (config.checkStart(action, afterState, prevState)) {
                  if (poller && poller.isActive()) {
                    poller.stop();
                  }
                  poller = newPoller(store);
                  poller.start();
                }
                if (poller && poller.isActive() && config.checkStop(action, afterState, prevState)) {
                  poller.stop();
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/poller.js
// module id = 77
// module chunks = 0